module.exports = __webpack_public_path__ + "img/tvc-icon.38f4a5d0.png";